<section class="template">
  <app-order-pdf-template-contractors
    [order]="order()"
  ></app-order-pdf-template-contractors>

  <div class="divider"></div>

  <app-order-pdf-template-details
    [order]="order()"
  ></app-order-pdf-template-details>

  <div class="divider"></div>

  <app-order-pdf-template-route
    [order]="order()"
  ></app-order-pdf-template-route>

  <div class="divider"></div>

  <app-order-pdf-template-rate [order]="order()"></app-order-pdf-template-rate>

  @if (order().outsourcingData?.executionTerms; as terms) {
    <div class="divider"></div>

    <section class="execution-terms f-body-xs">
      <p class="f-body-xs f-muted">
        {{ 'labels.terms' | translate | uppercase }}
      </p>

      <div class="terms">{{ terms }}</div>
    </section>
  }

  <div class="signatures">
    <section class="signature">
      <p class="f-body-l">
        {{ order().author | onyxName }}
      </p>

      <div class="separator"></div>

      <div class="f-body-2xs">
        {{ 'labels.principal' | translate }}
      </div>
    </section>

    <section class="signature">
      <div class="separator"></div>

      <div class="f-body-2xs">
        {{ 'labels.serviceProvider' | translate }}
      </div>
    </section>
  </div>
</section>
